/** Tactical teaching model, not a prescribed location under Rule 7.4.
 * Reference: USA Volleyball Indoor High Performance Boys Training Manual,
 * p.33, perimeter defence vs outside/rightside/front-1 attacks.
 * https://cdn3.sportngin.com/attachments/document/0120/6224/2017_USA_Volleyball_Indoor_High_Performance_Boys_Training__Manual__2_.pdf
 * Coordinates adapt those principles to this app; the central quick assumes
 * one blocker. Use team-specific coaching when a different block is called.
 */
import type {Spot} from './types';
export type AttackZone=2|3|4;
export type DefenceJob='block'|'short'|'line'|'deep'|'angle';
/** Perimeter teaching positions, in our court coordinates. Wing blocks take angle;
 * line stays with the back defender. A central quick uses one middle blocker. */
export function defencePlan(spots:ReadonlyMap<string,Spot>,slots:ReadonlyMap<string,number>,attack:AttackZone){
 const front=[...slots].filter(([,z])=>z>=2&&z<=4).map(([r])=>r).sort((a,b)=>spots.get(a)!.x-spots.get(b)!.x);
 const back=[...slots].filter(([,z])=>z===1||z>=5).map(([r])=>r).sort((a,b)=>spots.get(a)!.x-spots.get(b)!.x);
 const targets=new Map<string,Spot>(),jobs=new Map<string,DefenceJob>();
 const put=(r:string,x:number,z:number,job:DefenceJob)=>{targets.set(r,{x,z});jobs.set(r,job);};
 const hitter={x:attack===4?4.05:attack===2?-4.05:0,z:attack===3?-1.7:-1.9};
 if(attack===3){
  put(front[1],0,.45,'block');put(front[0],-2.5,2.7,'short');put(front[2],2.5,2.7,'short');
  put(back[0],-3.3,5.5,'angle');put(back[1],.2,7.8,'deep');put(back[2],3.3,5.5,'angle');
 }else{
  const sign=attack===4?1:-1;
  const pin=attack===4?front[2]:front[0],off=attack===4?front[0]:front[2];
  put(pin,sign*4.05,.45,'block');put(front[1],sign*3.15,.45,'block');put(off,-sign*1.5,2.4,'short');
  put(attack===4?back[2]:back[0],sign*4.3,4.6,'line');
  put(back[1],sign*.2,7.8,'deep');put(attack===4?back[0]:back[2],-sign*3.4,6.6,'angle');
 }
 return {spots:targets,jobs,hitter,blockers:[...jobs].filter(([,j])=>j==='block').map(([r])=>r)};
}
